import { RootState } from "../store";

export const selectPizza = (state: RootState) => state.pizza;

